export const DATE_FORMAT = 'dd/MM/yyyy';
export const TIME_FORMAT = 'HH:mm:ss';
export const DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm:ss';

export const RFC3339 = "yyyy-MM-dd'T'HH:mm:ssXXX";
export const DATE_FILTER_FORMAT = 'yyyy-MM-dd';

export const ENVIRONMENT: 'dev' | 'test' | 'uat' | 'prod' =
	(process.env.REACT_APP_ENV as any) ?? 'prod';
